import Vue from 'vue'
import VueZoomer from 'vue-zoomer'

Vue.use(VueZoomer)

export default VueZoomer